import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import { FeatureSnapshot } from 'components/FeatureSnapshot';
import { StaticImage } from 'gatsby-plugin-image';
import funnel from "../../../../contents/images/funnels.png";
import * as React from 'react';
export default {
  getImage,
  GatsbyImage,
  FeatureSnapshot,
  StaticImage,
  funnel,
  React
};